import { useRouter } from 'next/router';

import { ShoppingMetaTag } from '@/src/@domain/shopping/components/meta-tag';
import { useGetMetaTag } from '@/src/hooks/use-get-meta-tag';
import { CDN_BASE_URL, WEB_BASE_URL } from '@/src/utils/link';

export const ProductDepositMetaData = () => {
  const { asPath } = useRouter();
  const { metaTag } = useGetMetaTag({
    title: '예금 금리, 우대금리, 가입조건 확인하기',
    description: '예금 실사용자들의 가입 금액별 받은 금리와 이자 계산까지!',
    keywords:
      '예금, 예금추천, 20대예금추천, 정기예금금리비교, 저축은행예금, 저축은행예금금리, 고금리예금, 금리높은예금, 사회초년생예금, 이율높은예금, 사회초년생신용카드, 뱅크샐러드, 뱅샐, banksalad',
    imageUrl: `${CDN_BASE_URL}/graphic/color/illustration/og-image/deposit-inquiry.png`,
  });

  return (
    <ShoppingMetaTag
      pageUrl={`${WEB_BASE_URL}${asPath.split('?')[0]}`}
      title={metaTag.title}
      description={metaTag.description}
      imageUrl={metaTag.imageUrl}
      keywords={metaTag.keywords}
    />
  );
};
